import { render, staticRenderFns } from "./TabFinish.vue?vue&type=template&id=8e1900c8&scoped=true"
import script from "./TabFinish.vue?vue&type=script&lang=ts"
export * from "./TabFinish.vue?vue&type=script&lang=ts"
import style0 from "./TabFinish.vue?vue&type=style&index=0&id=8e1900c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1900c8",
  null
  
)

export default component.exports